/**
 * User-facing copy for the outcome of a book order placed from a checkout
 * (the draft checkout and the "Buy again" re-order checkout), and for the
 * "Buy again" state on Ordered books. No copy for these states is written
 * inline in the components.
 */
const strings = {
  confirmed: {
    title: 'Thank you. Your order is confirmed!',
    description: 'Please allow 7-10 days for us to print and ship your order.',
    action: 'View order',
  },
  // The order waits for the member's e-mail approval (50 or more copies).
  approval: {
    badge: 'ACTION NEEDED',
    title: 'Check your inbox to approve your order',
    // `{orderId}` renders in bold as `#<orderId>`.
    body:
      'We sent the approval e-mail for order {orderId}. Your {quantity} copies are printed only after you approve, then arrive in 7-10 days.',
    action: 'View order',
    footnote: 'No e-mail? Check your spam folder or write to support@authorify.com.',
  },
  // The book builder refused the order.
  refusal: {
    title: 'We couldn’t place this order',
    notInPlan:
      'This book is no longer included in your plan, so it can’t be re-ordered. No credits were used.',
    catalogLink: 'Browse the book catalog',
    generic:
      'Please try again in a few minutes. If it keeps happening, write to support@authorify.com.',
  },
  // Ordered books: the book is not in the member's current plan.
  notInPlan: {
    chip: 'No longer in your plan',
    link: 'See books in your plan',
  },
};

export default strings;
